



















































































































































import { Component, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import Draggable from "vuedraggable";
import BucketingGroups from "@/components/buckets/BucketingGroups.vue";
import _ from "lodash";


@Component({components: {BinSet: BucketingGroups, Draggable}})
export default class CategoricalScoringDefinitionRuleCreator extends Vue {

    @Model()
    scoringRules!: any[];

    @Prop()
    scoringKeys!: any[];

    @Prop()
    categoricalValues!: string[];

    @Prop()
    values!: string[];

    @Prop()
    tab!: number;

    private scoringKeyBins: string[][] = [];

    private additionalValues: string[] = [];

    private addValueDialog = false;
    private newValue = '';

    mounted() {
        if (this.scoringRules.length > 0) {
            // while (this.scoringKeys.length !== 0) {
            //     this.scoringKeys.splice(0, 1)
            // }
            for (let index = 0; index < this.scoringRules.length; index++) {
                let scoringRule = this.scoringRules[index];
                // this.scoringKeys.splice(this.scoringKeys.length, 0, scoringRule.scoringKey);
            }
            this.scoringKeyBins = this.scoringRules.map((sr, index) => Object.keys((sr.categoricalScoringMap)))
        } else {
            this.initializeScoringRules()
        }

    }

    get allValues() {
        let vals: string[] = JSON.parse(JSON.stringify(this.values || []));
        if (this.scoringRules) {
            let scoringRulesValues = _.flatten(this.scoringRules.map(sr => Object.keys(sr.categoricalScoringMap)))
            vals.push(...scoringRulesValues);
        }
        vals.push(...this.additionalValues)
        return vals
    }

    get allUniqueValues() {
        let values = [];
        values.push(...this.allValues)
        if (this.categoricalValues) {
            values.push(...this.categoricalValues)
        }
        return _.uniq(values)
    }

    get valuesBinValues() {
        let vals = this.allUniqueValues;
        if (this.scoringRules) {
            let scoringRulesValues = _.flatten(this.scoringRules.map(sr => Object.keys(sr.categoricalScoringMap)))
            _.pull(vals, ...scoringRulesValues);
        }
        return vals;
    }

    get valueCounts() {
        let counts = _.countBy(this.values)
        for (let v in this.allValues) {
            if (!counts.hasOwnProperty(this.allValues[v])) {
                counts[this.allValues[v]] = 0;
            }
        }
        return counts;
    }

    get chartLabels() {
        return Object.keys(this.valueCounts);
    }

    get chartSeriesData() {
        return [{name: "Count", data: Object.values(this.valueCounts)}]
    }

    get chartOptions() {
        return {
            chart: {
                type: 'bar',
                height: 350,
                toolbar: {
                    show: false
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true,
                    distributed: false,
                    barHeight: '20%'
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: this.chartLabels,
                // labels: {
                //     formatter: (value: number) => value % 1 === 0 ? value.toFixed(0) : ''
                // }
            }
        }
    }

    private initializeScoringRules() {
        this.scoringKeys.forEach((sk, index) => {
            let scoringRule = {
                scoringKey: sk,
                categoricalScoringMap: {}
            }
            this.scoringRules.splice(this.scoringRules.length, 0, scoringRule)
        })
        this.scoringKeyBins = this.scoringRules.map((sr, index) => Object.keys((sr.categoricalScoringMap)))
    }

    private addValue(newValue: string) {
        if (this.allValues.includes(newValue)) {
            return;
        }
        this.additionalValues.splice(this.additionalValues.length, 0, newValue)
        this.addValueDialog = false;
        this.newValue = ''
    }

    private deleteAdditionalValue(element: string) {
        this.additionalValues.splice(this.additionalValues.indexOf(element), 1)
        this.updateScoringRules();
    }

    private updateScoringRules() {
        this.scoringKeyBins.forEach((skb, index) => {
            this.scoringRules[index].categoricalScoringMap = skb.reduce((map: any, obj: string) => (map[obj] = 1.0, map), {});
        })
    }

    @Watch('scoringRules', {deep:true})
    private onWatchRules(newVal: [], oldVal: []){
        if(newVal.length === 0) {
            this.initializeScoringRules()
        }
    }

}
